import { Person } from '@/models/person/classes/Person'
import { InjectionKey, Ref } from 'vue'

export const PersonKey: InjectionKey<Ref<Person|null>> = Symbol('person')
